<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="on_close"
    class="!max-w-[1200px]">
    <template v-slot:modalHeader>
      <div class="flex flex-grow flex-wrap items-center justify-end gap-2">
        <h1
          class="flex-grow text-2xl font-bold leading-none text-core-900 lg:text-3xl">
          Information
        </h1>
      </div>
    </template>
    <template v-slot:modalBody>
      <div
        class="py-4 text-lg"
        v-if="!elearning">
        Veuillez saisir le questionnaire de satisfaction pour accéder au
        support.
      </div>
      <div
        class="py-4 text-lg"
        v-else>
        Veuillez finir votre module elearning et saisir le questionnaire de
        satisfaction pour accéder au support.
      </div>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      class?: string;
      elearning?: boolean;
    }>(),
    {
      class: ''
    }
  );
</script>

<style lang="scss" scoped></style>
